/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RenterCompanyViewModel,
    RenterCompanyViewModelFromJSON,
    RenterCompanyViewModelFromJSONTyped,
    RenterCompanyViewModelToJSON,
} from './RenterCompanyViewModel';

/**
 * 
 * @export
 * @interface RenterCompanyViewModelPagedDataModel
 */
export interface RenterCompanyViewModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<RenterCompanyViewModel>}
     * @memberof RenterCompanyViewModelPagedDataModel
     */
    data?: Array<RenterCompanyViewModel> | null;
}

export function RenterCompanyViewModelPagedDataModelFromJSON(json: any): RenterCompanyViewModelPagedDataModel {
    return RenterCompanyViewModelPagedDataModelFromJSONTyped(json, false);
}

export function RenterCompanyViewModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenterCompanyViewModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(RenterCompanyViewModelFromJSON)),
    };
}

export function RenterCompanyViewModelPagedDataModelToJSON(value?: RenterCompanyViewModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(RenterCompanyViewModelToJSON)),
    };
}

